function getFontSizeValue(size, theme) {
  return theme.fn.size({
    size: size,
    sizes: theme.fontSizes
  });
}

export { getFontSizeValue };